import React from "react";

// external improrts
import Typography from "@mui/material/Typography";

const CopyRight = (props) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      className="fw-bold"
      {...props}
    >
      {"Copyright © "}
      <a
        color="inherit"
        href="https://www.readysteadyplug.com/"
        sx={{ fontWeight: "bold" }}
        className="text-primary fw-bold "
      >
        ReadySteadyPlug
      </a>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default CopyRight;
